var _style, _polyline, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreejsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "171.7,621.7 20,18.4 620,186.9 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 245.8,
    y1: 362.4,
    x2: 283.7,
    y2: 513.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 395.5,
    y1: 404.8,
    x2: 245.8,
    y2: 362.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 283.7,
    y1: 513.3,
    x2: 395.5,
    y2: 404.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,470.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 283.7,
    y1: 513.3,
    x2: 134,
    y2: 470.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,470.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "134,470.9 171.9,621.9 283.7,513.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 134,
    y1: 470.9,
    x2: 245.8,
    y2: 362.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 245.8,
    y1: 362.4,
    x2: 357.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 357.7,
    y1: 253.8,
    x2: 469.5,
    y2: 145.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.8,
    y1: 102.9,
    x2: 357.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 357.7,
    y1: 253.8,
    x2: 207.9,
    y2: 211.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 207.9,
    y1: 211.5,
    x2: 245.8,
    y2: 362.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 245.8,
    y1: 362.4,
    x2: 96.1,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 96.1,
    y1: 320,
    x2: 134,
    y2: 470.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 58.2,
    y1: 169.1,
    x2: 96.1,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 207.9,
    y1: 211.5,
    x2: 58.2,
    y2: 169.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 96.1,
    y1: 320,
    x2: 207.9,
    y2: 211.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 207.9,
    y1: 211.4,
    x2: 319.8,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.8,
    y1: 102.9,
    x2: 170,
    y2: 60.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 170,
    y1: 60.5,
    x2: 207.9,
    y2: 211.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "58.2,169.1 20.3,18.1 170,60.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 58.2,
    y1: 169.1,
    x2: 170,
    y2: 60.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "507.4,296.2 619.2,187.7 469.5,145.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 469.5,
    y1: 145.3,
    x2: 507.4,
    y2: 296.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 507.4,
    y1: 296.2,
    x2: 357.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 357.7,
    y1: 253.8,
    x2: 395.5,
    y2: 404.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 395.5,
    y1: 404.8,
    x2: 507.4,
    y2: 296.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 469.5,
    y1: 145.3,
    x2: 319.8,
    y2: 102.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejsLogo);
export default __webpack_public_path__ + "static/media/Threejs-logo.34faec932f70929fc2778eaf26de073c.svg";
export { ForwardRef as ReactComponent };